// extracted by mini-css-extract-plugin
module.exports = {"main":"ordersPage_statuses_main__3t3un"};